import { render, staticRenderFns } from "./imageloader.vue?vue&type=template&id=08e8faef&scoped=true&"
import script from "./imageloader.vue?vue&type=script&lang=js&"
export * from "./imageloader.vue?vue&type=script&lang=js&"
import style0 from "./imageloader.vue?vue&type=style&index=0&id=08e8faef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e8faef",
  null
  
)

export default component.exports